import React, { createContext, useContext, useState, useCallback } from "react";

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface PageInfo {
  breadcrumbs: BreadcrumbItem[];
  subtitle?: string;
}

interface PageInfoContextValue {
  pageInfo: PageInfo;
  setPageInfo: (info: PageInfo) => void;
}

const PageInfoContext = createContext<PageInfoContextValue>({
  pageInfo: { breadcrumbs: [] },
  setPageInfo: () => {},
});

export const PageInfoProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [pageInfo, setPageInfoState] = useState<PageInfo>({
    breadcrumbs: [],
  });

  const setPageInfo = useCallback((info: PageInfo) => {
    setPageInfoState(info);
  }, []);

  return (
    <PageInfoContext.Provider value={{ pageInfo, setPageInfo }}>
      {children}
    </PageInfoContext.Provider>
  );
};

export const usePageInfo = () => useContext(PageInfoContext);
